'use client';

import { EditableContent } from '../../edit/EditableContent';
import { defaultPrivatePartyFields } from '../../lib/defaultFormFields';
import { parseFormFields } from '../../lib/parseFormFields';
import { pickBlockField } from '../../lib/localized';
import { pickChrome } from '../../lib/siteChromeCopy';
import type { BlockRenderProps } from '../../types';
import { FormFieldControl } from '../forms/FormFieldControls';
import { SiteLeadForm } from '../forms/SiteLeadForm';

export function PrivatePartyInquiryForm({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const heading = pickBlockField(block.content, 'heading', locale);
  const supporting = pickBlockField(block.content, 'supporting', locale);
  const ctaLabel = pickBlockField(block.content, 'ctaLabel', locale);
  const note = pickBlockField(block.content, 'note', locale);
  const target = isActive ? activeEditTarget : null;
  const operational = parseFormFields(pickBlockField(block.content, 'formFields', locale));
  const fields = operational.length > 0 ? operational : defaultPrivatePartyFields(locale);
  const formKey = block.dataBinding?.kind === 'form' ? block.dataBinding.formKey : 'private_party';

  return (
    <section
      className={['ws-party-inquiry', isActive ? 'ws-block--active' : '']
        .filter(Boolean)
        .join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      id="party"
    >
      <div className="ws-party-inquiry__inner">
        <EditableContent
          as="h2"
          fieldKey="heading"
          editable={editable}
          activeEditTarget={target}
          className="ws-party-inquiry__title"
        >
          {heading}
        </EditableContent>
        <EditableContent
          fieldKey="supporting"
          editable={editable}
          activeEditTarget={target}
          className="ws-party-inquiry__supporting"
        >
          {supporting}
        </EditableContent>
        <SiteLeadForm
          locale={locale}
          formKey={formKey}
          editable={editable}
          className="ws-party-inquiry__form"
        >
          {fields.map((field) => (
            <FormFieldControl
              key={field.name}
              field={field}
              locale={locale}
              fieldClassName="ws-form__field"
              editable={editable}
              activeEditTarget={target}
            />
          ))}
          <EditableContent
            as="button"
            type="submit"
            fieldKey="ctaLabel"
            editable={editable}
            activeEditTarget={target}
            className="ws-party-inquiry__submit"
          >
            {ctaLabel || pickChrome('submitFallbackReservation', locale)}
          </EditableContent>
        </SiteLeadForm>
        {note || editable ? (
          <EditableContent
            fieldKey="note"
            editable={editable}
            activeEditTarget={target}
            className="ws-party-inquiry__note"
          >
            {note}
          </EditableContent>
        ) : null}
      </div>
    </section>
  );
}
